// extracted by mini-css-extract-plugin
module.exports = {"gwCoverageClausesContainer":"EditCoverages_gwCoverageClausesContainer__25G2X"};